import { OperatorPanelWrapperFullSize } from '../../components/Layout'
import { IDoor } from './types'
import { FormattedMessage } from 'react-intl';
import { Badge } from 'baseui/badge';
import { SmallPanel } from './SmallPanel';

export const OperatorPanel = (props: IDoor) => {

    return (
            <OperatorPanelWrapperFullSize
                objectId={props.id}
                resourceGroupId={props.resourceGroupId}
                statusContent={
                    <>
                        <SmallPanel {...props}></SmallPanel>
                        {!props.isOpen &&
                            <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.CLOSED" defaultMessage="CLOSED" />} />
                        }
                    </>
                }>
            </OperatorPanelWrapperFullSize>
    )
}
